/* 俄语 */
export default {
  local: {
    reacquire_password: "Получить новый через ",

    account_login: "учетную запись",
    mobile_number_login: "Мобильный",
    authentication_code_login: "По коду",
    account_name_email: "Учетная запись/эл. почта",
    forgot_password: "Забыли пароль?",
    please_enter_the_account_number: "Пожалуйста, введите учетную запись",
    please_enter_the_password: "Пожалуйста, введите пароль",
    account_not_registered: "Учетная запись не зарегистрирована",
    incorrect_password: "Неверный пароль",
    not_joined_the_class:
      "Вы не присоединились к группе или группа, к которой вы присоединились, еще не появилась",
    password_lock_time:
      "Пароль был введен неправильно слишком много раз, пожалуйста, повторите попытку через 10 минут",
    password_lock:
      "Текущая учетная запись заблокирована, пожалуйста, повторите попытку позже",
    phone_number: "Номер телефона",
    please_enter_your_mobile_number:
      "Пожалуйста, введите номер мобильного телефона",
    mobile_number_format_error: "Ошибка формата номера мобильного телефона",
    mobile_number_is_not_registered:
      "Номер мобильного телефона не зарегистрирован",
    verification_code: "Код из СМС",
    get_verification_code: "Получить код",
    please_enter_the_verification_code: "Пожалуйста, введите проверочный код",
    code_failure_or_error:
      "Срок действия проверочного кода истек или он неверен",
    code_too_many_times:
      "Количество получений проверочного кода превысило лимит, пожалуйста, повторите попытку через 24 часа",
    go_back: "Назад",
    reset_your_password: "Сброс пароля",
    new_password: "Новый пароль",
    save_changes: "Подтвердить",
    reset_the_password_by_using_the_email_address:
      "Используйте почту для сброса",
    please_enter_the_password_address: "Пожалуйста, установите пароль",
    your_password_has_been_reset: "Успешный сброс пароля",
    password_rule: "Комбинация из 6-18 букв и символов",
    emai: "Электронная почта",
    reset_the_password_by_using_the_mobile_number:
      "Используйте телефон для сброса",
    please_enter_the_email_address:
      "Пожалуйста, введите адрес электронной почты",
    unregistered_mailbox: "Электронная почта не зарегистрирована",

    student: "Ученик",
    teacher: "Преподаватель",
    assistant: "Ассистент преподавателя",
    sign_in: "Присоединиться",
    identity_to_sign_in: "Пожалуйста, выберите статус входа",
    change_password: "Изменить пароль",
    switch_identity: "Переключить статус",
    sign_out: "Выйти из системы",
    class_on_phones: "С мобильного",
    mobile_terminal_by_scanning:
      "Вы можете получить доступ к мобильному\n" +
      "терминалу, отсканировав QR-код или открыв\n" +
      "ссылку",
    copy_link: "Скопировать ссылку",
    shut_off: "Закрыть",
    account: "Учетная запись",
    old_password: "Старый пароль",
    re_enter_password: "Введите еще раз",
    please_enter_the_old_password: "Пожалуйста, введите старый пароль",
    please_enter_the_new_password: "Пожалуйста, введите новый пароль",
    please_re_enter_the_new_password:
      "Пожалуйста, введите новый пароль еще раз",
    password_modified_successfully: "Пароль был успешно изменен",
    old_password_error: "Неправильный старый пароль",

    user_name: "Имя пользователя",
    password: "Пароль",
    login: "Логин",
    the_user_name_or_password_is_incorrect:
      "Неправильное имя пользователя или пароль",
    note: "Примечание",
    log_out: "Выход",
    certificate_application: "Заявка на диплом",
    more: "Подробнее",
    close: "Закрыть",
    learn_courses: "Изучать курсы",
    class_schedule: "Расписание занятий",
    data_download: "Скачать материалы",
    selective_courses: "Факультативные курсы",
    receive_notices: "Получать информацию",
    to_do_list: "Список дел",
    important_notices: "Важная информация",
    write_summary: "Писать отчёт",
    project_comment: "Оценить проект",
    evaluate_service_quality: "Оценить качество обслуживания",
    feedback: "Отзыв",
    my_summary: "Мой отчёт",
    completed: "Завершенный",
    unavailable: "Недоступный",
    uncompleted: "Незавершенный",
    coming_soon: "Страница в разработке",
    application_successful: "Заявка на диплом отправлена!",
    the_certificate_will_be_sent_to_your_mail:
      "После прохождения проверки, диплом будет отправлен на ваш электронную почту в тот день завершения курса.Если у вас возникнут вопросы, обратитесь к  руководителю группы.",
    ok: "Да",
    please_complete_your_to_do_list:
      "Подать заявку на диплом после того, что выполнить ваш список дел.",
    to_complete: "Да",
    would_you_like_to_check_your_reports:
      "Нужно ли вам просматривать соответствующие отчеты перед подачей заявку на диплом",
    no_modification_upon_submission: "После подачи, изменение запрещено!",
    go_and_check: "Пересматривать",
    submit: "Утвердить подачу",
    application_submitted: "Заявка отправлена",
    my_class: "Мой класс",
    course_calendar: "Занятия на календаре",
    back_to_today: "Сегодня",
    today: "Сегодня",
    course_replay: "Отложенный просмотр занятий",
    no_courses: "Нет занятий",
    monday: "Понедельник",
    tuesday: "Вторник",
    wednesday: "Среда",
    thursday: "Четверг",
    friday: "Пятница",
    saturday: "Суббота",
    sunday: "Воскресенье",
    instructor: "Преподаватель",
    comment: "Оценка",
    replay: "Смотреть ещё раз",
    join: "Идти на занятия",
    class_begins_at: "Занятие начинается в",
    lasting_for: "Продолжительность",
    all: "Все",
    video: "Видео",
    image: "Картинка",
    no_data: "Нет материалов",
    china_today_serial_courses: "Китай на сегодняшний день",
    language: "Язык",
    features: "Тема",
    finance: "Финансирование",
    trade: "Торговля",
    commerce: "Бизнес",
    planning: `China's Urban Planning`,
    infrastructure: `China's Infrastructure`,
    development_cooperation: `China's International Development Cooperation`,
    important_notices_title: "Важная информация",
    all_notes: "Все",
    course: "Информация о занятиях",
    event: "Информация о мероприятиях",
    class: "Информация о классе",
    task: "Информация о задаче",
    no_notes: "Нет информаций",
    content: "Детали информаций",
    turn_to_page: "Перейти на страницу XXX",
    please_complete_the_report: "Выполните отчёт о XXX",
    please_complete_the_course_comment: "Оцените занятие XXX",
    fill_in: "Заполнять",
    no_matter: "Нет дел",
    list: "Содержание",
    original: "Оригинал",
    speed: "Скорость",
    scored: "Балл XXX",
    fill_in_at_least_XXX_characters: "Заполнять не менее чем XXX знаков",
    words_already_entered: "Уже заполнялись XXX слов",
    submission_successful: "Успешно отправить",
    up_to_10000_words: "Не более 10 тыс. слов!",
    up_to_20000_words: "Не более 20 тыс. слов!",
    up_to_50000_words: "Не более 50 тыс. слов!",
    course_comment: "Оценить занятие",
    to_submit: "Отправить",
    to_close: "Закрыть",
    instructions: "Инструкция по завершению",
    evaluation_type: "Объект Оценки",
    very_good: "очень хорошо",
    good: "хорошо",
    bad: "плохо",
    total_points: "Общая оценка",
    trainers_level: "Уровень обучения лекторов",
    teaching_material_quality: "Качество  учебников",
    translation_level: "Уровень перевода",
    interactive_communication_situation: "Взаймное общение",
    multimedia_teaching_quality: "Качество мильтимедийного обучения ",
    course_degree_of_difficulty: "Уровень сложности уроков",
    correlation_between_course_and_the_program_theme:
      "Соотношение содержания лекций с темой проекта",
    comment_table_score_hint:
      "Примечание: очень хорошо-2 балла, хорошо-1 балл, плохо-0 баллов. Максимальная оценка каждого предмета-14 баллов.",
    participants_feedback_form: "Бланк отзыва участников",
    participants_feedback_form_state:
      "Сердечно желаем вам успешного завершения задач,выдвиньте ваши отзывы на этот семинар",
    participants_feedback_form_instructions:
      "Бланк-отзы, которую заполняют курсанты, в основном представляет собой их мнения и предложения по целому семинару.<br/>" +
      "Помимо отзывов о мнениях по текущему проекту, мы хотим узнать о ваших потребностях и предложениях по будущим проектам, в том числе:<br/>" +
      "1.Какие темы курсов вы бы хотели, чтобы мы предложили?<br/>" +
      "2.Какие китайские города вы хотели бы посетить?<br/>" +
      "3.Какие виды китайских предприятий вы хотели бы посетить?<br/>" +
      "4.Есть ли у вас планы торгово-экономического, образовательного или иного сотрудничества в Китае или городе Шанхай?<br/>" +
      "5.Есть ли у вас конкретные потребности в торгово-коммерческом сотрудничестве?",
    final_report: "Суммировать доклад",
    final_report_state:
      "Сердечно желаем вам успешного завершения задач, Пожалуйста напишите заключительный доклад этого семинара.",
    final_report_instructions:
      "Содержание  отчета курсанта может включать следующие четыре аспекта:<br/>" +
      "1. Основная информация о курсанте и цель для участия в семинаре.<br/>" +
      "2. Сравниваемый отчет. Сравните различия между страной курсанта и Китаем в соответствующих тематических областях. Касающиеся направления не ограничены.<br/>" +
      "3. Разделение яркими событиями и достижениями в обучении.<br/>" +
      "4. Выражение ожидания после обучения.",
    trainee_evaluation_form_of_foreign_assistance_training_program:
      "Оценочная анкета для обучающихся по подготовительному проекту",
    trainee_evaluation_form_of_foreign_assistance_training_program_state:
      "Благодарим Вас за участие в нашем проекте курса изучения/обучения. Для постоянного улучшения нашей работы, просим Вас сделать объективную оценку по поводу нашего проекта и высказать Ваше мнения по поводу нижеуказанных вопросов. Благодарим Вас за ваше сотрудничество.",
    trainee_evaluation_form_of_foreign_assistance_training_program_instructions:
      "Форма оценки проекта представляет собой всестороннюю оценку данного учебного проекта, и есть надежда, что оценка сможет точно отразить конкретное положение о семинаре, выполняемом базой. Заключения в форме оценки имеют большое значение для улучшения будущей работы и признания текущей работы Базы. <span>5</span> баллов за каждый предмет оценки - это наивысший балл, общая оценка - <span>100</span> баллов.",
    foreign_aid_training_service_quality_survey:
      "Опрос Шанхайской школы бизнеса по качеству программ подготовки представителей международной помощи 		",
    foreign_aid_training_service_quality_survey_state:
      "Благодарим за прохождение этой программы подготовки.  Чтобы помочь улучшить общее качество наших программ подготовки представителей международной помощи, просим вас пройти этот опрос по оценке обслуживания и оставить свои комментарии и отзывы, которые станут важным ориентиром для определения сфер для улучшения.  ",
    foreign_aid_training_service_quality_survey_instructions:
      'Оцените каждую сферу, поставив отметку (√) в поле, которое означает соответствующую оценку.  Оценка означает ваш уровень удовлетворенности: 5 = очень удовлетворен(а), 4 = удовлетворен(а), 3 = нейтральное отношение, 2 = неудовлетворен(а) и 1 = очень неудовлетворен(а).  Если у вас есть какие-либо дополнительные комментарии или предложения, укажите их в разделе "Комментарии". ',
    points: "Оценка ",
    training: "Обучение",
    course_arrangement: "Расписание уроков",
    suitability_of_course_quantity: "Количество уроков или лекицй",
    quality_of_teaching_materials_or_handouts: "Качество учебников или пособий",
    correlation_between_study_tours_and_the_program_theme:
      "Связь между организованным посещением и нашим проектом",
    arrangement_for_study_tours_or_internships:
      "Организация посещения и осмотра или практической деятельности",
    classrooms_and_teaching_equipments: "Учебные помещение и оборудования",
    management: "Управление",
    accommodation:
      "Условия проживания(если предлагается не каждому одельный одноместный номер, можно поставить 0 в оценке)",
    airport_transfer_and_catering_services_arrangement:
      "Встреча в аэропорту/провождение в аэропорт и питание",
    opening_and_closing_ceremonies_arrangement:
      "Организация церемонии начала и окончания учебы",
    cultural_experience_and_extracurricular_activities_arrangement:
      "Организация культурных деятельностей и внеурочных деятельностей",
    attitude_of_the_Chinese_staff: "Отношение Китайского рабочего персонала",
    organizational_skills_of_the_Chinese_staff:
      "Организационная способность китайского рабочего персонала",
    english_communication_skills_of_the_Chinese_staff:
      "Способность китайского рабочего персонала общаться на иностранных языках",
    synthesis: "Общие",
    program_duration: "Длительность проекта",
    help_of_the_program_on_your_future_work:
      "Польза данного проекта для Вашей будущей работы",
    role_of_the_program_in_promoting_cooperation_between_China_and_your_country_in_the_relevant_fields:
      "Значение данного проекта для развития сотрудничества в соответствующих сферах между Китаем и Вашей страной",
    your_overall_evaluation_of_the_program: "Ваша общая оценка",
    your_suggestion_and_comment: "Ваши советы и замечания",
    your_impression_of_China: "Ваши впечатления о Китае",
    report: "доклад",
    error_request: "Запрос не выполнен.",
    download_live_streaming_tool: "Скачать инструмент для прямого эфира.",
    windows_7_and_above: "Windows 7 или выше",
    no_replay: "Нет повтора.",
    look_over: "Проссматривать",
    mon: "Пн",
    tue: "Вт",
    wed: "Ср",
    thu: "Чт",
    fri: "Пт",
    sat: "Сб",
    sun: "Вс",
    please_enter_a_user_name: "Введите имя пользователя.",
    your_login_has_timed_out_please_click_the_button_to_log_in_again:
      "Время входа в систему истекло, нажмите кнопку, чтобы войти снова.",
    please_complete_all_comments_before_submission:
      "Завершите все оценки перед передачей!",
    please_fill_in: "Введите.",
    it_cannot_be_empty: "Не может быть пустым.",
    comment_successful: "Успешная оценка.",
    if_there_is_no_prompt_on_the_browser_please_try_again:
      "Если в браузере нет указания, попробуйте еще раз.",
    click_here_to_try_again: "Нажмите сюда, чтобы попробовать еще раз.",
    if_you_have_not_installed_the_live_streaming_tool:
      "Если инструмент прямого эфира не был установлен, скачайте и попробуйте еще раз.",
    class_information: "Информация о классе",
    reload: "Перезагрузить",
    you_do_not_have_permission_to_access_the_current_page:
      "У вас нет доступа к текущей странице",
    return_to_home_page: "Домашняя страница",
    total_points_project_comment: "Общее количество баллов по оценке",
    record_course_over_tip_msg:
      "Занятия закончились. Войдите в интерактивный класс пожалуйста",
    page_live_entry_tips:
      "Если вы не можете войти в Classin, посетите веб-страницу для обучения.<br>(В интернете не может взаимодействовать с учителем\n)",
    page_live_entry_txt: "Онлайн-уроки",
    select_class: "Выбор группы",
    start: "Начало учебы",
    download: "Нажмите для загрузки",
    class_on_phones: "С мобильного",
    class_on_phones_tip:
      "Вы можете получить доступ к мобильному терминалу, отсканировав QR-код или открыв ссылку",
    copy_successfully: "Копия выполнена"
  }
};



// WEBPACK FOOTER //
// ./src/lang/ru-RU/index.js